<template>
    <div>
        <v-autocomplete
            v-model="fieldAutocomplete.vModel"
            :items="fieldAutocomplete.items"
            :loading="fieldAutocomplete.isLoading"
            :search-input.sync="fieldAutocomplete.search"
            :error-messages="fieldErrors"
            :class="{ 'error--text': fieldErrors.length }"
            item-text="brand"
            item-value="id"
            :label="inputLabel"
            :data-vv-as="inputLabel"
            placeholder="Tastati denumirea"
            return-object
            no-filter
        >
            <template v-slot:selection="data">
                <v-chip
                    v-if="data.item"
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    @click="data.select"
                    @click:close="remove(data.item)"
                >
                    {{ data.item.brand }} {{ data.item.model }} - {{ data.item.vehicle_plate }}
                </v-chip>
            </template>
            <template v-slot:item="data">
                <v-list-item-content>{{ data.item.brand }} {{ data.item.model }} - {{ data.item.vehicle_plate }}</v-list-item-content>
            </template>
            <template v-slot:append-outer>
                <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="primary"
                    @click="dialog = true"
                >
                    <v-icon dark>
                        mdi-plus
                    </v-icon>
                </v-btn>
            </template>
        </v-autocomplete>
        <template v-if="expand">
            <v-text-field
                v-model="fieldAutocomplete.vModel.brand"
                :disabled="true"
                class="primary--text"
                name="brand"
                label="Marca"
                data-vv-as="Marca"
                data-vv-name="brand"
            />
            <v-text-field
                v-model="fieldAutocomplete.vModel.model"
                :disabled="true"
                class="primary--text"
                name="model"
                label="Model"
                data-vv-as="Model"
                data-vv-name="model"
            />
            <v-text-field
                v-model="fieldAutocomplete.vModel.chassis"
                :disabled="true"
                class="primary--text"
                name="chassis"
                label="Serie sasiu"
                data-vv-as="Serie sasiu"
                data-vv-name="chassis"
            />
            <v-text-field
                v-model="fieldAutocomplete.vModel.engine"
                :disabled="true"
                class="primary--text"
                name="engine"
                label="Serie motor"
                data-vv-as="Serie motor"
                data-vv-name="engine"
            />
            <v-text-field
                v-model="fieldAutocomplete.vModel.vehicle_plate"
                :disabled="true"
                class="primary--text"
                name="vehicle_plate"
                label="Numar inregistrare/inmatriculare"
                data-vv-as="Numar inregistrare/inmatriculare"
                data-vv-name="vehicle_plate"
            />
            <v-textarea
                v-model="fieldAutocomplete.vModel.data.remarks"
                :disabled="true"
                class="primary--text"
                name="data.remarks"
                label="Observatii"
                data-vv-as="Observatii"
                data-vv-name="data.remarks"
            />
        </template>
        <v-btn v-if="expandeable" block color="primary" class="my-3" @click="expand = !expand">{{ !expand ? 'Mai multe' : 'Mai putin' }}</v-btn>
        <v-dialog v-if="expandeable" v-model="dialog" width="50vw">
            <v-card>
                <v-card-title>
                    Adaugare vehicul
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete
                                    v-model="form.customer_id"
                                    :items="customers"
                                    item-value="id"
                                    item-text="name"
                                    v-validate="'required'"
                                    :error-messages="errorMessages('customer_id')"
                                    :class="{ 'error--text': hasErrors('customer_id') }"
                                    class="primary--text"
                                    name="customer_id"
                                    label="Client / Proprietar"
                                    data-vv-as="Client / Proprietar"
                                    data-vv-name="customer_id"
                                />
                                <v-text-field
                                    v-model="form.brand"
                                    v-validate="'required'"
                                    :error-messages="errorMessages('brand')"
                                    :class="{ 'error--text': hasErrors('brand') }"
                                    class="primary--text"
                                    name="brand"
                                    label="Marca"
                                    data-vv-as="Marca"
                                    data-vv-name="brand"
                                    counter="255"
                                />
                                <v-text-field
                                    v-model="form.model"
                                    v-validate="'required'"
                                    :error-messages="errorMessages('model')"
                                    :class="{ 'error--text': hasErrors('model') }"
                                    class="primary--text"
                                    name="model"
                                    label="Model"
                                    data-vv-as="Model"
                                    data-vv-name="model"
                                    counter="255"
                                />
                                <v-text-field
                                    v-model="form.chassis"
                                    :error-messages="errorMessages('chassis')"
                                    :class="{ 'error--text': hasErrors('chassis') }"
                                    class="primary--text"
                                    name="chassis"
                                    label="Serie sasiu"
                                    data-vv-as="Serie sasiu"
                                    data-vv-name="chassis"
                                    counter="255"
                                />
                                <v-text-field
                                    v-model="form.engine"
                                    :error-messages="errorMessages('engine')"
                                    :class="{ 'error--text': hasErrors('engine') }"
                                    class="primary--text"
                                    name="engine"
                                    label="Serie motor"
                                    data-vv-as="Serie motor"
                                    data-vv-name="engine"
                                    counter="255"
                                />
                                <v-text-field
                                    v-model="form.vehicle_plate"
                                    :error-messages="errorMessages('vehicle_plate')"
                                    :class="{ 'error--text': hasErrors('vehicle_plate') }"
                                    class="primary--text"
                                    name="vehicle_plate"
                                    label="Numar inregistrare/inmatriculare"
                                    data-vv-as="Numar inregistrare/inmatriculare"
                                    data-vv-name="vehicle_plate"
                                    counter="255"
                                />
                                <v-textarea
                                    v-model="form.data.remarks"
                                    :error-messages="errorMessages('data.remarks')"
                                    :class="{ 'error--text': hasErrors('data.remarks') }"
                                    class="primary--text"
                                    name="data.remarks"
                                    label="Observatii"
                                    data-vv-as="Observatii"
                                    data-vv-name="data.remarks"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-divider/>

                <v-card-actions>
                    <v-btn
                        color="secondary"
                        @click="closeDialog">
                        <v-icon left>arrow_left</v-icon>
                        Anulare
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                        color="primary"
                        @click="submit">Salveaza
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import validationError from "Mixins/validation-error";
import openAPI from "Mixins/openapi";
import {Form} from "vform";
import throttle from 'lodash/throttle'

export default {
    mixins: [validationError, openAPI],
    props: {
        inputLabel: {
            type: String,
            default () {
                return 'Denumire'
            }
        },
        expandeable: {
            type: Boolean,
            default() {
                return false
            }
        },
        value: {
            type: [Object, Number],
            default() {
                return null
            }
        },
        initialItems: {
            type: Array,
            default() {
                return []
            }
        },
        customerId: {
            type: Number,
            default() {
                return undefined
            }
        },
        fieldErrors: {
            type: Array,
            default() {
                return []
            }
        },
        returnObject: {
            type: Boolean,
            default() {
                return false
            }
        },
        autocomplete: {
            type: Boolean,
            default () {
                return true
            }
        }
    },
    data () {
        return {
            loading: true,
            dialog: false,
            expand: false,
            fieldAutocomplete: {
                vModel: {
                    id: null,
                    name: null,
                    phone: null,
                    email: null,
                    trade_registry_no: null,
                    vat_no: null,
                    bank: null,
                    iban: null,
                    country: null,
                    county: null,
                    city: null,
                    address: null,
                    data: {
                        due_days: null,
                        contact_person: null,
                        remarks: null
                    },
                },
                items: this.initialItems.filter(item => !_.isNil(item?.id)),
                isLoading: false,
                search: null,
            },
            form: new Form({
                id: null,
                name: null,
                phone: null,
                email: null,
                trade_registry_no: null,
                vat_no: null,
                bank: null,
                iban: null,
                country: null,
                county: null,
                city: null,
                address: null,
                data: {
                    due_days: null,
                    contact_person: null,
                    remarks: null
                },
            }),
            customers: []
        }
    },
    watch: {
        value: {
            handler(val) {
                this.handleValueChange(val)
            },
            deep: true
        },
        'fieldAutocomplete.vModel': {
            handler(val) {
                this.$emit('input', this.returnObject ? val : val?.id)
            },
            deep: true
        },
        'fieldAutocomplete.search': {
            handler: throttle(async function (val) {
                var self = this
                if (!this.autocomplete) return
                if (this.fieldAutocomplete.isLoading || this.loading || this._.isNil(val) || (val instanceof String && val.length < 3)) return
                this.fieldAutocomplete.isLoading = true
                var query = this.$db.Vehicle
                    .where('autocomplete', val)

                if(this.customerId) query = query.for((new this.$db.Customer({id: this.customerId})))

                await query
                    .get()
                    .then(({data}) => {
                        self.fieldAutocomplete.items = data
                    })
                    .finally(() => {
                        self.fieldAutocomplete.isLoading = false
                    })
            }, 500),
        },
        customerId: {
            async handler(val) {
                await this.loadCustomerVehicles(val)
            }
        },
        dialog: {
            async handler (val) {
                if (val && this.customers.length < 1) {
                    var query = this.$db.Customer
                        .select('id', 'name')
                        .limit(10000)
                    if (this.customerId) {
                        query = query.where('id', this.customerId)
                    }
                    const {meta, data} = await query.get()
                    this.customers = data
                    if (data.length) {
                        this.form.customer_id = data[0].id
                    }
                    if(this.id) {
                        await this.loadResource()
                    }
                }
            }
        }
    },
    async mounted() {
        this.handleValueChange(this.value)
        this.loading = false
        if (!this._.isNil(this.customerId)) {
            await this.loadCustomerVehicles(this.customerId)
        }
    },
    methods: {
        closeDialog() {
            this.dialog = false;
        },
        handleValueChange: throttle(async function (val) {
            if(!this._.isEqual(val, this.fieldAutocomplete.vModel)) {
                if(!this._.isNil(val)) {
                    if(val instanceof Object) {
                        this.fieldAutocomplete.items.push(val)
                        this.fieldAutocomplete.vModel = val
                    } else if (parseInt(val) > 0) {
                        var foundIndex = this.fieldAutocomplete.items.findIndex(item => item.id === val)
                        if(foundIndex >= 0) {
                            this.fieldAutocomplete.vModel = this.fieldAutocomplete.items[foundIndex]
                        } else {
                            this.$db.Vehicle.find(val).then(({data}) => {
                                this.fieldAutocomplete.vModel = data
                                this.fieldAutocomplete.items.push(data)
                            })
                        }
                    }
                } else {
                    this.resetForm()
                }
            }
        }, 500),
        async submit() {
            let self = this;
            this.$validator.validateAll().then(result => {
                if (result) {
                    // eslint-disable-next-line
                    self.createOrUpdate();
                } else {
                    this.showError()
                }
            });
        },
        async createOrUpdate() {
            let self = this;
            self.form.busy = true;

            var model = new this.$db.Vehicle(self.form);

            if (this.customerId) {
                model = model.for(new this.$db.Customer({id: this.customerId}))
            }
            if (this.id) {
                model.id = this.id
            }

            model.save()
                .then(response => {
                    self.$validator.reset();
                    this.showSuccess();
                    self.$nextTick(() => {
                        self.fieldAutocomplete.vModel = Object.assign({}, response)
                        self.fieldAutocomplete.items.push(self.fieldAutocomplete.vModel)
                        self.dialog = false
                        self.resetForm()
                    });
                })
                .catch(errors => {
                    self.form.errors.set(this.form.extractErrors(errors.response))
                    this.showError()
                }).finally(() => {
                self.form.busy = false;
            });
        },
        async searchVatAndFillValues() {
            await this.searchVatNo(this.form.vat_no)
                .then(({data}) => {
                    var splicedAddress = this._.get(data, 'adresa', '').split(',')
                    var city = splicedAddress.pop()
                    var address = splicedAddress.join(',')
                    var vatNo = !this._.isNil(data?.tva) ? `RO${data.cif}` : data?.cif
                    this.form = new Form(Object.assign(this.form, {
                        name: data?.denumire,
                        phone: data?.telefon,
                        trade_registry_no: data?.numar_reg_com,
                        vat_no: vatNo,
                        country: 'Romania',
                        county: data?.judet,
                        city: city,
                        address: address
                    }))
                })
        },
        async loadCustomerVehicles(customerId) {
            this.fieldAutocomplete.isLoading = true
            await this.$db.Vehicle
                .where('customer_id', customerId)
                .get()
                .then(({data}) => {
                    this.fieldAutocomplete.items = data
                })
                .finally(() => {
                    this.fieldAutocomplete.isLoading = false
                })
        },
        resetForm() {
            this.form = new Form({
                id: null,
                name: null,
                phone: null,
                email: null,
                trade_registry_no: null,
                vat_no: null,
                bank: null,
                iban: null,
                country: null,
                county: null,
                city: null,
                address: null,
                data: {
                    due_days: null,
                    contact_person: null,
                    remarks: null
                },
            })
        }
    }
};
</script>
